import styled from 'styled-components';
import { DropdownItem, DropdownMenu } from 'reactstrap';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { color } from '../../../assets/styles/colors';

export const DropdownItemNotification = styled(DropdownItem)`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  padding-left: 0;

  &:hover {
    background-color: ${color.lightGray};
  }
`;

export const SwitchNotificationDivBottom = styled.div`
 	display: flex;
	text-align: center;
	background-color: ${color.primary};
	justify-content: center;
	padding-top: 15px;
	padding-bottom: 15px;
	border-radius: 0px;
	cursor: pointer;
`;

export const DropdownItemVerTodas = styled(DropdownItem)`
  display: flex;
  align-items: center;
  text-align: center;

  &:hover {
    background-color: ${color.lightGray};
  }
`;

export const DropdownButton = styled.div`
	width: 100%;
	margin: 0;
	padding: 0;
	text-align: left;
	border-radius: 0px;
	border: 0;

	&:hover {
		background-color: ${color.primary} !important;
	}
`;

export const SwitchNotification = styled.div`
 	display: flex;
	width: 400px;
	justify-content: center;
	background-color: ${color.primary};
	align-items: center;
`;

export const SwitchNotificationDiv = styled.div`
	text-align: center;
	background-color: ${color.primary};
	padding: 37px;
	border-radius: 0px;
`;

export const DropdownMenuStyledNotification = styled(DropdownMenu)`
	display: flex;
	justify-content: center;

	transition: none !important;
	border-radius: 30px 0px 0px 0px !important;

	.dropdown-item {
		display: flex;
		align-items: center;
		svg {
			color: ${color.black};
			margin-right: 10px;
		}

		&:hover {
			text-decoration: underline;
			background-color: unset !important;
			color: ${color.softBlack} !important;
		}

		&:focus {
			background-color: unset !important;
			color: ${color.softBlack} !important;
		}
	}

	&:before {
		border: 0 !important;
	}

	&:after {
		border: 0 !important;
	}

	@media (max-width: 400px) {
		max-width: 290px;
	}

	@media (min-width: 412px) and (max-width: 900px) {
		max-width: 320px;
	}

	@media screen and (max-width: 590px) {
		&.notification-dropdown{
			margin-bottom: 103px;
			margin-left: -5px;
			max-width: 100vw;
			left: 0;
			top:0;
			padding: 0px;
			z-index: 9998;
		}
	}
`;

export const AddCircleOutlineIconStyled = styled(AddCircleOutlineIcon)`
  color: ${color.primary};
`;

export const ImgNotificationNone = styled.img`
	margin-right: 10px;
	filter: brightness(0);
`;
